import { SingleValueConfigProperties } from './types/single-value.js';

export const defaultSingleValueConfig: SingleValueConfigProperties = {
  alignment: 'start',
  colorRules: [],
};

export const SINGLE_VALUE_ARIA_LABEL = 'Single Value';
